import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { exportToCSV, exportCalendarToPDF } from '../../../utils/exportUtils';

const ExportImportControls = ({ activities, persons, currentDate }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleExportCSV = () => {
    const csvData = activities?.map(activity => ({
      Date: activity?.date || '',
      Time: activity?.time || '',
      Title: activity?.title || '',
      Person: activity?.personName || '',
      Location: activity?.location || '',
      Category: activity?.category || '',
      Description: activity?.description || ''
    })) || [];
    
    exportToCSV(csvData, 'family-calendar.csv');
    setShowMenu(false);
  };

  const handleExportPDF = () => {
    exportCalendarToPDF(activities, persons, currentDate);
    setShowMenu(false);
  };

  return (
    <div className="relative">
      <Button
        variant="outline"
        iconName="download"
        onClick={() => setShowMenu(!showMenu)}
      >
        Export
      </Button>

      {showMenu && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setShowMenu(false)}
          />
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-border z-50">
            <div className="py-2">
              <button
                onClick={handleExportCSV}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2"
              >
                <Icon name="file-text" size={16} />
                Export as CSV
              </button>
              <button
                onClick={handleExportPDF}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2"
              >
                <Icon name="file" size={16} />
                Export as PDF
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ExportImportControls;